export default [
    {
        characterImg: `assets/chars/anna/kissingCasual.webp`,
        speakerTxt: `It can't be real. Her lips against mine. It is the most beautiful thing that ever happened.`,
        speakerTxtRS: `Ne može biti stvarno. Njene usne uz moje. To je nešto najlepše što se ikada dogodilo.`,
        dialogFx: `assets/dialog/joseph/joseph0103.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/openSmileBlushCasual.webp`,
        speakerTxt: `See you next week.`,
        speakerTxtRS: `Vidimo se sledeće nedelje.`,
        dialogFx: `assets/dialog/anna/anna0039.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        characterImg: `unset`,
        speakerTxt: `[Same night ...]`,
        speakerTxtRS: `[Iste vačeri ...]`
    },
    {
        backgroundImg: `assets/bgImgs/diary.webp`,
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `Despite everything, I have always believed that I will find my treasure somewhere, in a dark recess of my heart. The most priceless gem I've ever discovered is wrapped in an Anna. When she shows up, everything seems to move slowly, like honey. Other than her, everything is hazy.`,
        speakerTxtRS: `I pored svega, oduvek sam verovao da ću negde pronaći svoje blago, u mračnoj zabiti srca. Najneprocenjiviji dragulj koji sam ikada otkrio je umotan u Anu. Kad se ona pojavi, čini se da se sve kreće polako, kao med. Osim nje, sve je maglovito.`,
        dialogFx: `assets/dialog/joseph/joseph0104.mp3`,
        soundFx: `assets/sounds/writing.mp3`,
        soundLoop: true,
    },
    {
        speakerTxt: `She showed up like a crescent moon in my life. She is as lovely and ideal as the crescent moon. I resembled a jigsaw puzzle with pieces missing. She showed up and completed me. I guarantee she will live a happy life.`,
        speakerTxtRS: `Ona je kao polumesec u mom životu. Ona je tako lepa i idealna kao polumesec. Ja sam bio kao slagalica sa nedostajućim delovima. Ona se pojavila i kompletirala me. Garantujem da će živeti srećan život.`,
        dialogFx: `assets/dialog/joseph/joseph0105.mp3`,
        soundFx: `assets/sounds/writing.mp3`,
        soundLoop: true,
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        speakerTxt: `THE END.`,
        speakerTxtRS: `KRAJ.`
    }
]